import { z } from 'zod';

import { defineFcm } from '../shared/factory';

export const FCM_SAP_AI_TEXT_LABELING = defineFcm('sap_ai_text_labeling')
	.asJson(
		z.object({
			copy: z.object({
				loadingHeading: z.string(),
				editorDisclaimer: z.string(),
				bannerDescription: z.string(),
			}),
		}),
	)
	.withDefault(undefined)
	.withMerger(({ localeValue, countryValue }) =>
		localeValue !== undefined && countryValue !== undefined ? localeValue : undefined,
	)
	.toConfig({
		owner: 'squad-starfish',
		scope: 'corgi-front-end',
		supportedGroups: { countries: true, locales: true },
		context: 'Start a Petition V2 (SAP) AI text labeling step experiment',
		description:
			'Gates the sap_ai_text_labeling step experiment on the Start a Petition flow (EU AI Act Art. 50 disclosure labels on AI-generated text) and carries the disclosure copy per locale. Configure the full copy object at both a locale and a country scope to enable the experiment for that market — the locale value supplies the copy shown.',
		mergeLogic:
			'Both a locale AND a country value must be configured for the config to resolve; if either is missing, the merged value is undefined and the experiment is disabled for that request. The locale value is the source of truth (it carries the disclosure copy). A value missing any copy field fails validation and likewise disables the experiment for that request.',
		template: {
			copy: {
				loadingHeading: 'Working on your petition draft with the help of AI…',
				editorDisclaimer: 'This petition was drafted with the help of AI, which can make mistakes.',
				bannerDescription:
					'You’re responsible for the text and images you publish. Refine the draft and continue to see your petition preview.',
			},
		},
	});
